import { DataDRequest } from "../../../data/DRequest";
import { _ModalConfirmacion } from "./ModalConfirmacion";
import { _ModalServiceIterator } from "./ModalServiceIterator";
import { Entidad } from "../../../data/Entidad";
import { ModalThingsUtil as util } from "./Utils";

type IResponseItemData<Data> = util.IResponseItemData<Data>
type IModalThingsBase1 = util.IModalThingsBase1
type IModalThings<Extras = any> = util.IModalThings<Extras>

export interface IModalServiceIteratorBasicConfig<TData> extends IModalThingsBase1 {
    /** Mensaje de confirmación para el usuario antes de continuar con el proceso */
    Message: string;
    OnDrawContent?: (content: TSelectionHTML<"div", any, any>, modalThings: IModalThings) => void;
    DataToProccess: Array<TData>;
    /** Se invoca al llamar al proceso de cada uno de los items del arreglo de datos
     * * Tiene prioridad sobre 'OnStepAllProccess'
     */
    OnStepAProccess: (itemData: TData) => Promise<NonNullable<DataDRequest.IResultadoPeticion<any>>>;
    /** Su uso supone que todos los elementos del arreglo se procesan al mismo tiempo (Ej.: En un solo servicio que recive una matriz)
     * * Solo se invoca si 'OnStepAProccess' no está definido
     */
    OnStepAllProccess?: (itemData: TData[]) => Promise<NonNullable<DataDRequest.IResultadoPeticion<any>>>;
    /** Acepta HTML */
    OnError_GetItemDataTag: (itemData: TData, container: TSelectionHTML<"div">) => (string | void);
    /** Se invoca al final de cada intento por procesar los datos faltantes (incluyendo la primera ves). No es el final de todo el proceso. */
    OnEndProccess?: (results: IResponseItemData<TData>[]) => void;
    // OnEndAllProccess: (itemsResult: Array<data.DRequest.IResultadoPeticion<any>>) => void;
    OnEvalRetry?: (results: IResponseItemData<TData>[]) => boolean;

    /** Si se define "Action", por default toma la cadena del key del enum, a menos que se defina
     * @deprecated
    */
    AccionToHttpMessage?: string;

    TypeRequest: Entidad.CTipoRequest;

    /** @default 500 */
    Width?: number;
}

/** * Verifica permisos antes de abrir el modal, en caso de no tener permisos, no abre el modal, se necesita: Action, Modulo, IdsEscuelas (Opcional)
 * * Al finalizar, verifica si existen items incorrectos y muestra un modal a modo de resumen,
 * * La promesa devuelve (en caso de tener permisos) la lista de todos los datos a procesar con sus respectivos resultados de proceso.
*/
export function _ModalServiceIteratorBasic<TData>(config: IModalServiceIteratorBasicConfig<TData>): Promise<IResponseItemData<TData>[] | null> {
    return new Promise((resolve1) => {
        let dataProccess: IResponseItemData<TData>[] = config.DataToProccess
            .map(d => ({
                Resultado: -1,
                ItemData: d,
                TipoRequest: config.TypeRequest,
            }));

        const cmt = _ModalConfirmacion({
            Title: config.Title,
            Message: config.Message,
            DrawContent: config.OnDrawContent,

            IdsEscuelas: config.IdsEscuelas,
            Modulo: config.Modulo,
            Action: config.Action,

            Width: config.Width,
            StrModalBotons: config.StrModalBotons,
            OnAccept: (modalThings) => _ModalServiceIterator(modalThings, dataProccess, config),
            OnClose: () => resolve1(dataProccess),
        });

        if (cmt == null) {
            resolve1(null);
        }
    });
}